import { useEffect, useState } from 'react';

type UseConnectionCheckOptions = {
  checkConnection: () => Promise<boolean>;
  isConnected: boolean;
  isDialogOpen: boolean;
};

export const useConnectionCheck = ({
  checkConnection,
  isConnected,
  isDialogOpen,
}: UseConnectionCheckOptions): boolean => {
  const [hasCheckedConnection, setHasCheckedConnection] = useState(false);

  useEffect(() => {
    if (!isDialogOpen) {
      setHasCheckedConnection(false);
      return undefined;
    }

    if (isConnected) {
      setHasCheckedConnection(true);
      return undefined;
    }

    let isCurrent = true;
    setHasCheckedConnection(false);

    void checkConnection().finally(() => {
      if (isCurrent) {
        setHasCheckedConnection(true);
      }
    });

    return () => {
      isCurrent = false;
    };
  }, [checkConnection, isConnected, isDialogOpen]);

  return isDialogOpen && !isConnected && !hasCheckedConnection;
};
